import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import { OrdersFacade } from '../../../+store/order/order.facade';
import { IOrder } from '@appgen-health-crm/api-interfaces';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { getTrackingLink } from '@care-portals/shared';
import { SHIPPING_CARRIERS } from '@care-portals/data';

@Component({
  selector: 'portals-emr-order-shipped-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule
  ],
  template: `
    <!-- Inline HTML goes here -->
    <form nz-form [formGroup]="FG">
      <nz-form-item>
        <nz-form-label nzFor="trackingCode">Tracking Code</nz-form-label>
        <nz-form-control nzErrorTip="Please enter the tracking number">
          <input
            nz-input
            type="text"
            formControlName="trackingCode"
            placeholder=""
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="carrier">Carrier</nz-form-label>
        <nz-form-control>
          <nz-select nz-input formControlName="carrier" placeholder="">
            <nz-option
              *ngFor="let carrier of carriers"
              [nzValue]="carrier.key"
              [nzLabel]="carrier.label"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <div class="text-center w-full my-2">OR</div>
      <nz-form-item>
        <nz-form-label nzFor="trackingLink">Tracking Link</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="trackingLink" placeholder="" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="sendEvent"
          >Send Event (trigger workflows)</nz-form-label
        >
        <nz-form-control>
          <input type="checkbox" formControlName="sendEvent" placeholder="" />
        </nz-form-control>
      </nz-form-item>
    </form>
    <div class="flex justify-end gap-2">
      <button
        nz-button
        nzType="default"
        [nzLoading]="orderFacade.loading$ | async"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="default"
        [disabled]="orderFacade.loading$ | async"
        (click)="ok()"
      >
        Skip
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="orderFacade.loading$ | async"
        (click)="ok()"
      >
        Save
      </button>
    </div>
  `,
  styles: [
    `
      /* Inline styles go here */
    `
  ]
})
export class OrderedShippedDialogComponent {
  readonly fb = inject(FormBuilder);
  readonly orderFacade = inject(OrdersFacade);
  readonly modal = inject(NzModalRef);
  readonly data: { order: IOrder; postalCode: string } = inject(NZ_MODAL_DATA);

  FG = this.fb.group({
    trackingCode: ['', []],
    carrier: ['', []],
    trackingLink: ['', []],
    sendEvent: [true, []]
  });

  carriers = SHIPPING_CARRIERS;

  ok() {
    if (this.FG.invalid) {
      for (const key in this.FG.controls) {
        this.FG.controls[key].markAsDirty();
        this.FG.controls[key].updateValueAndValidity();
      }
    }
    const { trackingCode, carrier, trackingLink, sendEvent } = this.FG.value;
    this.orderFacade.updateOrder(this.data.order.id, {
      status: 'shipped',
      trackingCode,
      trackingLink:
        trackingLink ||
        getTrackingLink(trackingCode, carrier, this.data.postalCode),
      sendEvent
    });
    this.modal.close();
  }

  cancel() {
    this.modal.close();
    this.orderFacade.updateOrderState(this.data.order.id, {
      status: this.data.order.status
    });
  }
}
